export function isProduction(): boolean {
	return (
		process.env.VERCEL_ENV === "production" ||
		process.env.NEXT_PUBLIC_VERCEL_ENV === "production"
	);
}
